import { render, staticRenderFns } from "./LeaderBoardTableRow.vue?vue&type=template&id=cb5fe7d4&scoped=true&"
import script from "./LeaderBoardTableRow.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardTableRow.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardTableRow.vue?vue&type=style&index=0&id=cb5fe7d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5fe7d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/nmg-charitychallenge.com/charity-challenge/frontbuild/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
installComponents(component, {VAvatar})
